import {Row, Col, Button, Modal, Form} from 'react-bootstrap';
import {useState, useEffect, useRef, useCallback} from 'react';
import { useCreateDeviceMutation, useUpdateDeviceMutation, useDeleteDeviceMutation } from '../../slices/devicesApiSlice';
import { toast } from 'react-toastify';
import { AgGridReact } from 'ag-grid-react'; 
import "ag-grid-community/styles/ag-grid.css"; 
import "ag-grid-community/styles/ag-theme-alpine.css"; 
import EditPhoneModal from './modals/EditPhoneModal';
import DeleteButtonCellRender from './cellRenders/DeleteButtonCellRender';
import EditButtonCellRender from './cellRenders/EditButtonCellRender';
import useDynamicHeight from '../../hooks/useDynamicHeight';

const SitePhones = ({sitePhones, site}) => {

    const newPhone = {
        name: '',
        type: 'phone',
        serial: '',
        firmware: '',
        mac: '',
        lanIP: '',
        wanIP: '',
        companyName: '',
        vendor: '',
        supportNumber: '',
        connType: '',
        user: '',
        site: site._id
    }
    const [createDevice, {isLoading, error}] = useCreateDeviceMutation();
    const [updateDevice] = useUpdateDeviceMutation();
    const [deleteDevice] = useDeleteDeviceMutation();
    const[phone, setPhone] = useState(newPhone);
    const[phones, setPhones] = useState(sitePhones);
    const[submitActionPhone, setSubmitActionPhone] = useState();
    const [showPhone, setShowPhone] = useState(false);
    const [showErrorPhone, setShowErrorPhone] = useState(false);
    const [quickFilterText, setQuickFilterText] = useState('');
    const [gridContainerRef, gridHeight] = useDynamicHeight([phones]);
    const phoneRef = useRef();
    phoneRef.current = phone;

    const phonesRef = useRef();
    phonesRef.current = phones;
        
    const gridRef = useRef();
    
    useEffect(() => {
        if(phones){
            setPhones(phones);
        }
    }, [phones])

    useEffect(() => {
        if(phone){
            setPhone(phone);
        }
    }, [phone])

    
    const handleCloseErrorPhone = () => {
        setShowErrorPhone(false);
        setPhone(newPhone);
    }
       
    const handleClosePhone = () => {
        setShowPhone(false);
        setPhone(newPhone);
    }
    const handleShowPhone = (e) => {
        setSubmitActionPhone(() => createDeviceHandler);
        setShowPhone(true);
    }

    const onChange = event => {
        const {name, value} = event.target;
        setPhone(prevState => ({
            ...prevState,
            [name]:value
        }));
    }

    const createDeviceHandler = async () => {
        setShowPhone(false);
        const currPhone = phoneRef.current;
        try{
            const res = await createDevice(currPhone).unwrap();
            toast.success(res.message);
            setPhones([...phones, res.addedDevice])
            setPhone(newPhone);
        }catch (error){
            toast.error(error?.data?.message || error.error);
        }
    }

    const [colDefs, setColDefs] = useState([
        {field: "name"},
        {field: "number"},
        {field: "user"},
        {field: "location"},
        {field: "vendor"},
        {field: "mac"},
        {headerName: 'Edit', field: 'actions', width:80, cellRenderer: EditButtonCellRender,
            cellRendererParams: {
                onEdit: (phone) => {
                    setPhone(phone);
                    setSubmitActionPhone(() => updateDeviceHandler);
                    setShowPhone(true);
                }
            }
        },
        {headerName: 'Delete', field: 'delete', cellRenderer: DeleteButtonCellRender,
            cellRendererParams: {
                onDelete: (deviceId) => {
                    deleteDeviceHandler(deviceId);
                }
            }
        }
    ]);

    const onExportClick = useCallback(() => {
        const fileName = site.name + '_phones_' + Date.now() + ".csv";
        gridRef.current.exportDataAsCsv({fileName: fileName});
      }, []);



      const onQuickFilterChange = (event) => {
        setQuickFilterText(event.target.value);
        if (gridRef.current && gridRef.current.api) {
          gridRef.current.api.setQuickFilter(event.target.value);
        }
      };
    
      const onGridReady = (params) => {
        gridRef.current = params.api;
      };
 
    const updateDeviceHandler = async () => {
        const currPhone = phoneRef.current;
        const updatedPhones = []
        const res = await updateDevice(currPhone).unwrap();
        phonesRef.current.map(arrphone => {
            if(arrphone._id == res.updatedDevice._id){
                updatedPhones.push(res.updatedDevice)
            } else {
                updatedPhones.push(arrphone);
            }
        });
        setPhones(updatedPhones);
        setShowPhone(false);
        toast.success(res.message);
    }

    const deleteDeviceHandler = (phoneId) => {
        phonesRef.current.map(phone => {
            if(phone._id === phoneId){
                setPhone(phone);
                setShowErrorPhone(true);
            }
           })
    }

    const removeDeviceHandler = async () => {
        const currPhone = phoneRef.current;
        const res = await deleteDevice(currPhone._id).unwrap();
        const index = phones.findIndex(phone => phone._id === currPhone._id);
        if (index !== -1) {
          const newArray = [...phones.slice(0, index), ...phones.slice(index + 1)];
          setPhones(newArray);
        }
        setShowErrorPhone(false);
        setPhone(newPhone);
        toast.success(res.message);
    }

    return  isLoading ? (
        <h2>Loading</h2>
    ): error ? (
        <div>{error?.data?.message || error.error}</div>
    ) : (
        <>


        <Modal show={showErrorPhone} onHide={handleCloseErrorPhone} centered>
            <Modal.Header closeButton>
            <Modal.Title>Delete Phone</Modal.Title>
            </Modal.Header>
            <Modal.Body>Are you sure you want to delete this phone?</Modal.Body>
            <Modal.Footer>
            <Button variant="secondary" onClick={handleCloseErrorPhone}>
                Close
            </Button>
            <Button variant="danger" onClick={removeDeviceHandler}>
                Delete
            </Button>
            </Modal.Footer>
        </Modal>


        {phone && (
        <EditPhoneModal
          show={showPhone}
          handleClose={handleClosePhone}
          phone={phone}
          onChange={onChange}
          onSave={submitActionPhone}
        />
      )}

        <Row className='align-items-right'>
            <Col className='text-end'>
                <Button className='btn-sm m-3 modalAddButton' data-type='modalAddButton' onClick={handleShowPhone}>
                    Add Phone
                </Button>
                <Button className='btn-sm m-3 modalAddButton' onClick={onExportClick}>Export to CSV</Button>
            </Col>
        </Row>


        <Row>
            <Col sm={3}>
            <Form.Control
                type="text"
                placeholder="Filter"
                value={quickFilterText}
                onChange={onQuickFilterChange}
                className="mb-3"
            />
            </Col>
      </Row>


        <Row>
            <Col>
                <div
                    ref={gridContainerRef}
                    className="ag-theme-alpine"
                    style={{ height: gridHeight }} 
                    >
                    <AgGridReact
                        ref={gridRef}
                        rowData={phones}
                        columnDefs={colDefs}
                        frameworkComponents={{
                            EditButtonCellRenderer: EditButtonCellRender,
                            DeleteButtonCellRender: DeleteButtonCellRender
                            }}
                        onGridReady={onGridReady}
                        quickFilterText={quickFilterText}
                    />
                </div>
            </Col>
        </Row>
        </>
    )
}

export default SitePhones;
